declare namespace $ {

	export class $shm_hitalama_map_widget_float_component_parser extends $shm_hitalama_map_widget_float_code {
		textarea_hint( ): string
		run( ): any
	}
	
}

//# sourceMappingURL=parser.view.tree.d.ts.map